module.exports = __webpack_public_path__ + "media/goforajourney/img/find-oaxaca-f67f14dd0d64da7be61a427ec8068e6a.jpg";